import React, { useState, useRef } from "react";
import "./SwInspectionReports.scss";
import { Grid, Popover, IconButton } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormLabels from "../../../../library/custom/formLabel/FormLabels";
import SearchAutoComplete from "../../../../library/custom/searchAutoComplete/SearchAutoComplete";
import {
  HBNEXT_ORG_ID,
  LOGIN_ORG_ID,
  ORG_ID,
  ORG_NAME,
  PAGE_SIZE,
  ROW_PER_PAGE_SIZE,
  USER_TYPE,
  visibleFieldsByStatus,
} from "../../../../constant/constant";
import DatePicker from "../../../../library/custom/datePicker/DatePicker";
import Cards from "../../../../feature/reports/component/Cards";
import {
  convertUTCtoLocalTimeZoneNA,
  getDateWithDayPast,
  getFormatedDate,
  stripTimeToDate,
} from "../../../../utils/helper";
import { useDebounce } from "../../../../utils/useDebounceSearch";
import { TableLoader } from "../../../../library/common/Loader";
import NORow from "../../../../library/custom/noRow/noRow";
import SettingTable from "../../../incidents/incidentList/SettingTable";
import GridTable from "../../../../library/custom/gridTable/GridTable";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect } from "react";
import { InputField } from "../../../../library/custom/textBox/InputField";
import * as userAction from "../../../../redux/actions/userAction";
import * as assetsAction from "../../../../redux/actions/assetsAction";
import { useSelector, useDispatch } from "react-redux";
import UserFilterList from "../../../admin/shared/UserFilterList ";
import FilterListIcon from "@mui/icons-material/FilterList";
import ReportRowManipulte from "../../../incidents/incidentList/ReportRowManipulte";
import { SW_INSPECTION_VIEW } from "../../../../constant/routeContant";
import { useNavigate } from "react-router-dom";
import { RemoveRedEye } from "@mui/icons-material";

function SwInspectionReports({
  autoSearchDataLoading,
  allClients,
  searchClient,
  allUsers,
  getSwInspectionList,
  getSwInspectionListData,
  isSearchClientLoading,
  inspectionTypeValue,
  dashboardReportPath,
  preservedState,
}) {
  const autoComp = useRef(null);
  const isFirstRender = useRef(true);

  const hasRestoredState = useRef(Boolean(preservedState));
  const dispatch = useDispatch();

  const ui = preservedState?.ui;
  const defaultSevenDayRange = getDateWithDayPast(7);

  const [clients, setClients] = useState(ui?.clients ?? "");
  const [usersValue, setUsersValue] = useState(ui?.usersValue ?? "");
  const [users, setUsers] = useState(ui?.users ?? "");
  const [days, setDays] = useState(
    ui?.days ?? (dashboardReportPath ? { key: 7, value: "7 days" } : ""),
  );
  const [startDate, setStartDate] = useState(
    ui?.startDate ??
      (dashboardReportPath ? defaultSevenDayRange.pastData : null),
  );
  const [endDate, setEndDate] = useState(
    ui?.endDate ??
      (dashboardReportPath ? defaultSevenDayRange.getCurrentDate : null),
  );
  const [search, setSearch] = useState(ui?.search ?? "");
  const debouncedSearch = useDebounce(search, 500);
  const [page, setPage] = useState(ui?.page ?? 0);
  const [projects, setProjects] = useState(ui?.projects ?? undefined);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isnepectionTypeId, setIsnepectionTypeId] = useState(
    ui?.isnepectionTypeId ?? "",
  );
  const [frequencyTypeId, setFrequencyTypeId] = useState(
    ui?.frequencyTypeId ?? "",
  );
  const [pageSize, setPageSize] = useState(ui?.pageSize ?? PAGE_SIZE);
  const [statusId, setStatusId] = useState(ui?.statusId ?? 6);
  const [inspectionSubmitType, setInspectionSubmitType] = useState(
    ui?.inspectionSubmitType ?? "",
  );
  const [statusIds, setStatusIds] = useState(ui?.statusIds ?? 5);
  const navigate = useNavigate();

  const [clientSearch, setClientSearch] = useState("");
  const debouncedClientSearch = useDebounce(clientSearch, 500);
  const [projectSearch, setProjectSearch] = useState("");
  const debouncedProjectSearch = useDebounce(projectSearch, 500);
  const [userSearch, setUserSearch] = useState("");
  const debouncedUserSearch = useDebounce(userSearch, 500);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const [deferLogAnchorEl, setDeferLogAnchorEl] = useState(null);
  const [deferLogRows, setDeferLogRows] = useState([]);

  const inspectionTypeIdOnChanges = (e) => {
    setIsnepectionTypeId(e.target.value);
  };

  const frequencyTypesOnChanges = (e) => {
    setFrequencyTypeId(e.target.value);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const InspectionSubmitTypeOnChanges = (e) => {
    setInspectionSubmitType(e.target.value);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenDeferLog = (event, details) => {
    setDeferLogAnchorEl(event.currentTarget);
    setDeferLogRows(details || []);
  };

  const handleCloseDeferLog = () => {
    setDeferLogAnchorEl(null);
  };

  const handleSearch = () => {
    setAnchorEl(null);
    setPage(0);
    const data = {
      search: search ? search : "",
      inspectionTypeId: isnepectionTypeId ? isnepectionTypeId : 0,
      projectId: projects?.key ? projects?.key : 0,
      customerId: clients?.key ? clients?.key : parseInt(ORG_ID()),
      statusId: statusId,
      frequencyId: frequencyTypeId ? frequencyTypeId : "",
      startDate: startDate ? getFormatedDate(startDate) : "",
      endDate: endDate ? getFormatedDate(endDate) : "",
      page: 1,
      pageSize: pageSize,
      userId: users ? users : "",
      inspectionSubmitType: inspectionSubmitType ? inspectionSubmitType : "",
      statusIds: statusIds,
    };
    getSwInspectionListData(data);
  };

  const allProject = useSelector((state) => state.getAssetDynomoList);
  const isProjectLoading = allProject?.isLoading;
  function handleAllProjectSearch(event, value) {
    setProjectSearch(event?.target?.value || "");
  }

  useEffect(() => {
    if (preservedState) return;
    if (ORG_ID() != LOGIN_ORG_ID()) {
      setClients({
        key: ORG_ID(),
        value: ORG_NAME(),
      });
    }
  }, []);

  useEffect(() => {
    if (hasRestoredState.current) {
      hasRestoredState.current = false;
    }
  }, []);

  useEffect(() => {
    if (!clients?.key || !projects?.key || !projects?.value) return;
    dispatch(
      assetsAction.getAssetDynomoList({
        searchText: String(projects.value || "").trim(),
        type: 5,
        orgId: clients.key,
      }),
    );
  }, [clients?.key, projects?.key, projects?.value, dispatch]);

  const searchUsers = (
    searchText,
    type,
    divisionId,
    assetType,
    assetId,
    priviledgeId,
    productId,
    orgId = clients?.key,
  ) => {
    dispatch(
      userAction.searchAllUsers(
        searchText,
        type,
        divisionId,
        assetType,
        assetId,
        17,
        productId,
        orgId,
      ),
    );
  };

  const handleApply = () => {
    setAnchorEl(null);
    const data = {
      search: search ? search : "",
      inspectionTypeId: isnepectionTypeId ? isnepectionTypeId : 0,
      projectId: projects?.key ? projects?.key : 0,
      customerId: clients?.key ? clients?.key : parseInt(ORG_ID()),
      statusId: statusId,
      frequencyId: frequencyTypeId ? frequencyTypeId : "",
      startDate: startDate ? getFormatedDate(startDate) : "",
      endDate: endDate ? getFormatedDate(endDate) : "",
      page: 1,
      pageSize: pageSize,
      userId: users ? users : "",
      inspectionSubmitType: inspectionSubmitType ? inspectionSubmitType : "",
      statusIds: statusIds,
    };
    getSwInspectionListData(data);
  };
  const handleClear = () => {
    setAnchorEl(null);
    setIsnepectionTypeId("");
    setFrequencyTypeId("");
    setSearch("");
    setStartDate(null);
    setEndDate(null);
    setPage(0);
    setPageSize(PAGE_SIZE);
    setInspectionSubmitType("");
    const data = {
      search: "",
      inspectionTypeId: 0,
      projectId: projects?.key ? projects?.key : 0,
      frequencyId: "",
      customerId: clients?.key ? clients?.key : parseInt(ORG_ID()),
      statusId: statusId,
      startDate: "",
      endDate: "",
      page: 1,
      pageSize: PAGE_SIZE,
      userId: users ? users : "",
      inspectionSubmitType: "",
      statusIds: statusIds,
    };
    getSwInspectionListData(data);
  };

  const handlePagignation = (newPage) => {
    setPage(newPage);
    const data = {
      search: search ? search : "",
      inspectionTypeId: isnepectionTypeId ? isnepectionTypeId : 0,
      projectId: projects?.key ? projects?.key : 0,
      customerId: clients?.key ? clients?.key : parseInt(ORG_ID()),
      frequencyId: frequencyTypeId ? frequencyTypeId : "",
      statusId: statusId,
      startDate: startDate ? getFormatedDate(startDate) : "",
      endDate: endDate ? getFormatedDate(endDate) : "",
      page: newPage + 1,
      pageSize: pageSize,
      userId: users ? users : "",
      inspectionSubmitType: inspectionSubmitType ? inspectionSubmitType : "",
      statusIds: statusIds,
    };
    getSwInspectionListData(data);
  };

  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    setPage(0);
    const data = {
      search: search ? search : "",
      inspectionTypeId: isnepectionTypeId ? isnepectionTypeId : 0,
      projectId: projects?.key ? projects?.key : 0,
      customerId: clients?.key ? clients?.key : parseInt(ORG_ID()),
      frequencyId: frequencyTypeId ? frequencyTypeId : "",
      statusId: statusId,
      startDate: startDate ? getFormatedDate(startDate) : "",
      endDate: endDate ? getFormatedDate(endDate) : "",
      page: 1,
      pageSize: newPazeSize,
      userId: users ? users : "",
      inspectionSubmitType: inspectionSubmitType ? inspectionSubmitType : "",
      statusIds: statusIds,
    };
    getSwInspectionListData(data);
  };

  const onChangeUsers = (value) => {
    setUsers(value?.key || "");
    setUsersValue({ key: value?.key ?? "", value: value?.value ?? "" });
    setPage(0);
    const data = {
      search: search ? search : "",
      inspectionTypeId: isnepectionTypeId ? isnepectionTypeId : 0,
      projectId: projects?.key ? projects?.key : 0,
      customerId: clients ? clients?.key : parseInt(ORG_ID()),
      frequencyId: frequencyTypeId ? frequencyTypeId : "",
      statusId: statusId,
      startDate: startDate ? getFormatedDate(startDate) : "",
      endDate: endDate ? getFormatedDate(endDate) : "",
      page: 1,
      pageSize: pageSize,
      userId: value?.key ? value?.key : "",
      inspectionSubmitType: inspectionSubmitType ? inspectionSubmitType : "",
      statusIds: statusIds,
    };
    getSwInspectionListData(data);
  };
  const onChangeProjects = (value) => {
    setProjects(value);
    setUsersValue("");
    setUsers("");
    setPage(0);
    const data = {
      search: search ? search : "",
      inspectionTypeId: isnepectionTypeId ? isnepectionTypeId : 0,
      frequencyId: frequencyTypeId ? frequencyTypeId : "",
      projectId: value?.key ? value?.key : 0,
      customerId: clients ? clients?.key : parseInt(ORG_ID()),
      statusId: statusId,
      startDate: startDate ? getFormatedDate(startDate) : "",
      endDate: endDate ? getFormatedDate(endDate) : "",
      page: 1,
      pageSize: pageSize,
      userId: value === null ? "" : users ? users : "",
      inspectionSubmitType: inspectionSubmitType ? inspectionSubmitType : "",
      statusIds: statusIds,
    };
    getSwInspectionListData(data);
  };

  const typeOnchange = (event, value) => {
    setClientSearch(event?.target?.value);
  };

  const onChangeClients = (value) => {
    setClients(value);
    setUsersValue("");
    setUsers("");
    setProjects("");
    setPage(0);
    const data = {
      search: search ? search : "",
      inspectionTypeId: isnepectionTypeId ? isnepectionTypeId : 0,
      projectId: value === null ? 0 : projects?.key ? projects?.key : 0,
      customerId: value?.key ? value?.key : parseInt(ORG_ID()),
      frequencyId: frequencyTypeId ? frequencyTypeId : "",
      statusId: statusId,
      startDate: startDate ? getFormatedDate(startDate) : "",
      endDate: endDate ? getFormatedDate(endDate) : "",
      page: 1,
      pageSize: pageSize,
      userId: value === null ? "" : users ? users : "",
      inspectionSubmitType: inspectionSubmitType ? inspectionSubmitType : "",
      statusIds: statusIds,
    };
    getSwInspectionListData(data);
  };

  const handleautoSearch = (event) => {
    setSearch(event.target.value || "");
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (hasRestoredState.current) return;
    setPage(0);
    const data = {
      search: debouncedSearch,
      inspectionTypeId: isnepectionTypeId ? isnepectionTypeId : 0,
      projectId: projects?.key ? projects?.key : 0,
      customerId: clients?.key ? clients?.key : parseInt(ORG_ID()),
      frequencyId: frequencyTypeId ? frequencyTypeId : "",
      statusId: statusId,
      startDate: startDate ? getFormatedDate(startDate) : "",
      endDate: endDate ? getFormatedDate(endDate) : "",
      page: 1,
      pageSize: pageSize,
      userId: users ? users : "",
      inspectionSubmitType: inspectionSubmitType ? inspectionSubmitType : "",
      statusIds: statusIds,
    };
    getSwInspectionListData(data);
  }, [debouncedSearch]);

  const cardOnClick = (value) => {
    setDays(value);
    if (days.key === value.key) {
      setDays("");
      const data = {
        search: search ? search : "",
        inspectionTypeId: isnepectionTypeId ? isnepectionTypeId : 0,
        projectId: projects?.key ? projects?.key : 0,
        customerId: clients?.key ? clients?.key : parseInt(ORG_ID()),
        frequencyId: frequencyTypeId ? frequencyTypeId : "",
        statusId: statusId,
        startDate: "",
        endDate: "",
        page: 1,
        pageSize: pageSize,
        userId: users ? users : "",
        inspectionSubmitType: inspectionSubmitType ? inspectionSubmitType : "",
        statusIds: statusIds,
      };
      getSwInspectionListData(data);
    } else {
      if (value.key !== 12) {
        let dateObj = getDateWithDayPast(value.key);
        const data = {
          search: search ? search : "",
          inspectionTypeId: isnepectionTypeId ? isnepectionTypeId : 0,
          projectId: projects?.key ? projects?.key : 0,
          customerId: clients?.key ? clients?.key : parseInt(ORG_ID()),
          frequencyId: frequencyTypeId ? frequencyTypeId : "",
          statusId: statusId,
          startDate: dateObj.pastData ? dateObj.pastData : "",
          endDate: dateObj.getCurrentDate ? dateObj.getCurrentDate : "",
          page: 1,
          pageSize: pageSize,
          userId: users ? users : "",
          inspectionSubmitType: inspectionSubmitType
            ? inspectionSubmitType
            : "",
          statusIds: statusIds,
        };
        getSwInspectionListData(data);
        setEndDate(dateObj.getCurrentDate);
        setStartDate(dateObj.pastData);
      }
      if (value.key === 13) {
        setStartDate("");
        setEndDate("");
        const data = {
          search: search ? search : "",
          inspectionTypeId: isnepectionTypeId ? isnepectionTypeId : 0,
          projectId: projects?.key ? projects?.key : 0,
          customerId: clients?.key ? clients?.key : parseInt(ORG_ID()),
          frequencyId: frequencyTypeId ? frequencyTypeId : "",
          statusId: statusId,
          startDate: "",
          endDate: "",
          page: 1,
          pageSize: pageSize,
          userId: users ? users : "",
          inspectionSubmitType: inspectionSubmitType
            ? inspectionSubmitType
            : "",
          statusIds: statusIds,
        };
        getSwInspectionListData(data);
      }
    }
  };

  const onchangeStartdatePicker = (e) => {
    setStartDate(e);
  };

  useEffect(() => {
    if (startDate && endDate && days.key === 12) {
      const data = {
        search: search ? search : "",
        inspectionTypeId: isnepectionTypeId ? isnepectionTypeId : 0,
        projectId: projects?.key ? projects?.key : 0,
        customerId: clients?.key ? clients?.key : parseInt(ORG_ID()),
        frequencyId: frequencyTypeId ? frequencyTypeId : "",
        statusId: statusId,
        startDate: startDate ? getFormatedDate(startDate) : "",
        endDate: endDate ? getFormatedDate(endDate) : "",
        page: 1,
        pageSize: pageSize,
        userId: users ? users : "",
        inspectionSubmitType: inspectionSubmitType ? inspectionSubmitType : "",
        statusIds: statusIds,
      };
      getSwInspectionListData(data);
    }
  }, [startDate, endDate]);

  const onchangeEnddatePicker = (e) => {
    setEndDate(e);
    const data = {
      search: search ? search : "",
      inspectionTypeId: isnepectionTypeId ? isnepectionTypeId : 0,
      projectId: projects?.key ? projects?.key : 0,
      customerId: clients?.key ? clients?.key : parseInt(ORG_ID()),
      frequencyId: frequencyTypeId ? frequencyTypeId : "",
      statusId: statusId,
      startDate: startDate ? getFormatedDate(startDate) : "",
      endDate: endDate ? getFormatedDate(e) : "",
      page: 1,
      pageSize: pageSize,
      userId: users ? users : "",
      statusIds: statusIds,
    };
    //  getSwInspectionListData(data);
  };

  const filterDays = [
    {
      key: 0,
      value: "Today",
    },
    {
      key: 7,
      value: "7 days",
    },
    {
      key: 14,
      value: "14 days",
    },
    {
      key: 30,
      value: "30 days",
    },
    {
      key: 12,
      value: "Custom",
    },
    {
      key: 13,
      value: "Reset",
    },
  ];

  const credcloumns = [
    { field: "reportId", headerName: "Report ID", flex: 2.8, hide: false },
    // { field: "projectNumber", headerName: "Project Number", flex: 4 },
    { field: "projectName", headerName: "project", flex: 4, hide: false },
    { field: "customer", headerName: "Client", flex: 4, hide: false },
    { field: "inspectionBy", headerName: "Inspector", flex: 3.5, hide: false },
    {
      field: "dateReported",
      headerName: "Date Submitted",
      flex: 3.5,
      hide: false,
      renderCell: ({ row }) => {
        const formatted = stripTimeToDate(row?.dateReported);
        return <div title={formatted}>{formatted || "N/A"}</div>;
      },
    }, // not show in missed
    {
      field: "dateOfEntry",
      headerName: "Inspection Date",
      flex: 3.5,
      hide: false,
    }, //  not show in missed
    {
      field: "openItemCount",
      headerName: "Opent Items",
      flex: 2.5,
      hide: false,
    },
    {
      field: "inspectionType",
      headerName: "Inspection Type",
      flex: 2.5,
      hide: false,
    },
    {
      field: "frequency",
      headerName: "Frequency",
      flex: 2.5,
      hide: false,
      renderCell: (rows) => {
        return (
          <>
            <div>
              <>
                {rows?.row?.frequency}{" "}
                {rows?.row?.frequencyId === 5 &&
                rows?.row?.isFluid &&
                rows?.row?.insTerm
                  ? `(${rows?.row?.insTerm})`
                  : ""}
                {rows?.row?.frequencyId === 7 ? (
                  <span
                    className="frequencyInDays"
                    title={rows?.row?.frequencyInDays}
                  >
                    {"- " + rows?.row?.frequencyInDays}
                  </span>
                ) : (
                  ""
                )}
              </>
            </div>
          </>
        );
      },
    },
    {
      field: "icon",
      renderHeader: () => (
        <SettingTable
          noOfRecords={getSwInspectionList?.recordsCount ?? 0}
          numberOfItemsPerPage={PAGE_SIZE}
          incidentLists={getSwInspectionList?.inspectionReports ?? []}
          fileNameXL={"InspectionList"}
        />
      ),
      width: 80,
      sortable: false,
      disableClickEventBubbling: true,
    },
  ];

  const viewOnClick = (row) => {
    const filterPayload = {
      search: search || "",
      inspectionTypeId: isnepectionTypeId ? isnepectionTypeId : 0,
      projectId: projects?.key ? projects.key : 0,
      customerId: clients?.key ? clients.key : parseInt(ORG_ID()),
      statusId,
      frequencyId: frequencyTypeId ? frequencyTypeId : "",
      startDate: startDate ? getFormatedDate(startDate) : "",
      endDate: endDate ? getFormatedDate(endDate) : "",
      page: page + 1,
      pageSize,
      userId: users ? users : "",
      inspectionSubmitType: inspectionSubmitType ? inspectionSubmitType : "",
      statusIds,
    };
    const uiState = {
      statusId,
      statusIds,
      days,
      startDate,
      endDate,
      search,
      page,
      pageSize,
      isnepectionTypeId,
      frequencyTypeId,
      inspectionSubmitType,
      clients,
      projects,
      users,
      usersValue,
    };
    sessionStorage.setItem("swInspReportsPreserve", "true");
    sessionStorage.setItem(
      "swInspReportsFilter",
      JSON.stringify(filterPayload),
    );
    sessionStorage.setItem("swInspReportsUI", JSON.stringify(uiState));

    navigate(SW_INSPECTION_VIEW, {
      state: {
        inspectionId: row?.reportId,
        customerId: row?.customerId,
      },
    });
  };

  const baseColumns = [
    { field: "reportId", headerName: "Report ID", flex: 1.5 },
    { field: "customer", headerName: "Client", flex: 2 },
    { field: "projectName", headerName: "Project", flex: 2.5 },
    { field: "inspectionBy", headerName: "Inspector", flex: 2 },
    {
      field: "dateScheduled",
      headerName: "Date Scheduled",
      flex: statusId === 9 ? 2.2 : 2.5,
      renderCell: ({ row }) => (
        <div title={row?.dateScheduled}>{row?.dateScheduled}</div>
      ),
    },
    {
      field: "dateReported",
      headerName: statusId === 5 ? "Date Missed" : "Date Submitted",
      flex: statusId === 9 ? 2.2 : 2.5,
      renderCell: ({ row }) => {
        const formatted = stripTimeToDate(row?.dateReported);
        return <div title={formatted}>{formatted || "N/A"}</div>;
      },
    },
    {
      field: "dateOfEntry",
      headerName: "Inspection Date",
      flex: 2,
      renderCell: ({ row }) => (
        <div title={row?.dateOfEntry}>{row?.dateOfEntry ?? "N/A"}</div>
      ),
    },
    { field: "inspectionType", headerName: "Inspection Type", flex: 2 },
    {
      field: "frequency",
      headerName: "Frequency",
      flex: 2,
      renderCell: (rows) => {
        return (
          <>
            <div title={rows?.row?.frequency}>
              <>
                {rows?.row?.frequency}{" "}
                {rows?.row?.frequencyId === 5 &&
                rows?.row?.isFluid &&
                rows?.row?.insTerm
                  ? `(${rows?.row?.insTerm})`
                  : ""}
                {rows?.row?.frequencyId === 7 ? (
                  <span
                    className="frequencyInDays"
                    title={rows?.row?.frequencyInDays}
                  >
                    {"-" + rows?.row?.frequencyInDays}
                  </span>
                ) : (
                  ""
                )}
              </>
            </div>
          </>
        );
      },
    },
    { field: "daysPastDue", headerName: "Days Past Due", flex: 1.5 },
    {
      field: "deferredCount",
      headerName: "Number of Times Deferred",
      flex: 1.5,
      renderCell: ({ row }) => {
        const details = row?.deferredDetails ?? [];
        const count = row?.deferredCount ?? "N/A";
        return (
          <div className="deferred-wrapper">
            <div className="deferred-names" title={String(count)}>
              {count}
            </div>
            {details.length > 0 && (
              <IconButton
                size="small"
                className="defer-log-btn"
                onClick={(e) => handleOpenDeferLog(e, details)}
              >
                <RemoveRedEye fontSize="small" />
              </IconButton>
            )}
          </div>
        );
      },
    },
    {
      field: "deferredDetails",
      headerName: "Who Deferred",
      flex: 3,
      renderCell: ({ row }) => {
        const details = row?.deferredDetails ?? [];
        const names =
          details
            .map((d) => d?.userName)
            .filter(Boolean)
            .join(", ") || "";
        return (
          <div className="deferred-wrapper">
            <div title={names} className="deferred-names">
              {names}
            </div>
          </div>
        );
      },
    },
    {
      field: "icon",
      renderHeader: () => (
        <SettingTable
          noOfRecords={getSwInspectionList?.recordsCount ?? 0}
          numberOfItemsPerPage={PAGE_SIZE}
          incidentLists={getSwInspectionList?.inspectionReports ?? []}
          fileNameXL={"InspectionList"}
        />
      ),
      width: 63,
      minWidth: 63,

      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        const row = rows?.row;
        if (statusId === 5) return "";
        if (statusId === 2 || statusId === 8 || statusId === 9) {
          const scheduledRaw = row?.dateScheduled;
          const scheduledStr =
            scheduledRaw != null ? String(scheduledRaw).trim() : "";
          const scheduledTime = new Date(scheduledRaw).getTime();
          const hasValidScheduled =
            scheduledStr !== "" &&
            scheduledStr.toUpperCase() !== "N/A" &&
            !Number.isNaN(scheduledTime);

          const hasValidReported = Boolean(
            convertUTCtoLocalTimeZoneNA(row?.dateReported, true),
          );

          if (!hasValidScheduled || !hasValidReported) return "";
        }

        return (
          <ReportRowManipulte
            rows={rows}
            view
            viewOnClick={(r) => viewOnClick(r)}
            viewLabel={"View Report"}
          />
        );
      },
    },
  ];

  const getColumns = () => {
    if (!dashboardReportPath) return credcloumns;

    const visibleFields = visibleFieldsByStatus[statusId];

    if (!visibleFields) return credcloumns;

    return baseColumns.filter((col) => visibleFields.includes(col.field));
  };

  const resolveStatusIds = (value) =>
    parseInt(value) === 6
      ? 5
      : parseInt(value) === 5
        ? 10
        : parseInt(value) === 2
          ? 0
          : parseInt(value) === 8
            ? 0
            : parseInt(value) === 9
              ? 0
              : parseInt(value);

  const statusHander = (value) => {
    const newStatusIds = resolveStatusIds(value);
    const tabSevenDayRange = getDateWithDayPast(7);

    setStatusId(value);
    setStatusIds(newStatusIds);
    setSearch("");
    setPage(0);
    setPageSize(PAGE_SIZE);
    setClients("");
    setProjects(undefined);
    setUsers("");
    setUsersValue("");
    setIsnepectionTypeId("");
    setFrequencyTypeId("");
    setInspectionSubmitType("");
    setDays(dashboardReportPath ? { key: 7, value: "7 days" } : "");
    setStartDate(dashboardReportPath ? tabSevenDayRange.pastData : null);
    setEndDate(dashboardReportPath ? tabSevenDayRange.getCurrentDate : null);

    getSwInspectionListData({
      search: "",
      inspectionTypeId: 0,
      projectId: 0,
      customerId: parseInt(ORG_ID()),
      frequencyId: "",
      statusId: value,
      startDate: dashboardReportPath ? tabSevenDayRange.pastData : "",
      endDate: dashboardReportPath ? tabSevenDayRange.getCurrentDate : "",
      page: 1,
      pageSize: PAGE_SIZE,
      userId: "",
      statusIds: newStatusIds,
      inspectionSubmitType: "",
    });
  };

  useEffect(() => {
    if (debouncedClientSearch !== "") {
      searchClient(debouncedClientSearch);
    }
  }, [debouncedClientSearch]);

  useEffect(() => {
    if (debouncedProjectSearch !== "") {
      dispatch(
        assetsAction.getAssetDynomoList({
          orgId: clients?.key ? clients?.key : parseInt(ORG_ID()),
          searchText: debouncedProjectSearch,
          type: 5,
        }),
      );
    }
  }, [debouncedProjectSearch]);

  useEffect(() => {
    if (debouncedUserSearch !== "") {
      searchUsers(debouncedUserSearch, USER_TYPE.EMPLOYEE);
    }
  }, [debouncedUserSearch]);
  return (
    <div className="SwInspectionReportAnlalytics">
      <div className="grid_heading_style">Inspection</div>
      {dashboardReportPath && (
        <>
          {/* {!isProfile && ( */}
          <div className="grid_main_header two_grid">
            <Grid container item md={12} xs={12} className="">
              <Grid container className="confBox">
                <Grid item md={8} xs={12}>
                  <div className="confTitile">
                    {/* {HBView || adminView
                        ? "Inspection Record"
                        : "My Inspection Record"} */}
                  </div>
                </Grid>

                <Grid item md={8} xs={12}>
                  <div className="btnStatusWrapper">
                    <div
                      className={
                        statusId === 5 ? "btnStatusIns active" : "btnStatusIns"
                      }
                      onClick={() => statusHander(5)}
                    >
                      Missed
                    </div>

                    <div
                      className={
                        statusId === 6 ? "btnStatusIns active" : "btnStatusIns"
                      }
                      onClick={() => statusHander(6)}
                    >
                      Completed
                    </div>

                    <div
                      className={
                        statusId === 2 ? "btnStatusIns active" : "btnStatusIns"
                      }
                      onClick={() => statusHander(2)}
                    >
                      Past Due
                    </div>

                    <div
                      className={
                        statusId === 9 ? "btnStatusIns active" : "btnStatusIns"
                      }
                      onClick={() => statusHander(9)}
                    >
                      Defferred
                    </div>
                    <div
                      className={
                        statusId === 8 ? "btnStatusIns active" : "btnStatusIns"
                      }
                      onClick={() => statusHander(8)}
                    >
                      Backdated
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </div>
          {/* )} */}
        </>
      )}
      <Grid item container spacing={3} mt={3}>
        <Grid item lg={5} xs={12} sm={12} md={6}>
          {ORG_ID() !== LOGIN_ORG_ID() ? (
            <FormControl fullWidth>
              <FormLabels label="Client" isRequired={false} />
              <InputField
                isRequired={false}
                type="text"
                placeholder={"Add Client Name Here..."}
                value={clients?.value}
                disabled={ORG_ID() !== 1}
              />
            </FormControl>
          ) : (
            <FormControl fullWidth>
              <FormLabels label="Select Client" isRequired={false} />
              <SearchAutoComplete
                name="orgName"
                placeholderText="Search Client"
                noOptionsTextMsg="No Client"
                optionsData={allClients?.data ?? []}
                typeOnchange={(event, value) => typeOnchange(event, value)}
                isKeyValuePair={true}
                value={clients}
                onChange={(event, value) => onChangeClients(value)}
                isLoading={isSearchClientLoading}
                autoCompClear={autoComp}
                disabled={parseInt(LOGIN_ORG_ID()) !== parseInt(HBNEXT_ORG_ID)}
              />
            </FormControl>
          )}
        </Grid>
        <Grid item lg={5} xs={12} sm={12} md={6}>
          <FormControl fullWidth>
            <FormLabels label="Project" isRequired={false} />
            <SearchAutoComplete
              name="Add Individual Users"
              placeholderText="Search Project"
              optionsData={allProject?.data ?? []}
              typeOnchange={(event, value) =>
                handleAllProjectSearch(event, value)
              }
              isKeyValuePair={true}
              value={projects}
              onChange={(e, value) => onChangeProjects(value)}
              isLoading={isProjectLoading}
              autoCompClear={autoComp}
              noOptionsTextMsg={"No Project"}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid item container spacing={3} mt={0}>
        <Grid item lg={5} xs={12} sm={12} md={6}>
          <FormControl fullWidth>
            <FormLabels label="Select Inspector" isRequired={false} />
            <SearchAutoComplete
              name="selectInspector"
              placeholderText="Search Inspector"
              optionsData={allUsers ?? []}
              // typeOnchange={(event, value) =>
              //   searchUsers(event.target.value, USER_TYPE.EMPLOYEE)
              // }
              typeOnchange={(event) =>
                setUserSearch(event?.target?.value || "")
              }
              isKeyValuePair={true}
              value={usersValue ? usersValue : ""}
              onChange={(event, value) => onChangeUsers(value)}
              isLoading={autoSearchDataLoading}
              noOptionsTextMsg={"No Inspector"}
            />
          </FormControl>
        </Grid>
      </Grid>

      <Grid item lg={8} xs={12} sm={12} md={8} mt={5}>
        <FormLabels label={"Select Time Period"} />
        <Cards
          staticCardData={true}
          cardData={filterDays}
          selectedVehicleAccident={days}
          cardClickHandler={cardOnClick}
        />
      </Grid>
      {days?.value === "Custom" ? (
        <>
          <Grid item container mt={1} spacing={1}>
            <Grid item lg={4} xs={12} sm={12}>
              <FormLabels label={"Custom Time Period"} isRequired={false} />
            </Grid>
          </Grid>

          <Grid item container spacing={2} mb={2}>
            <Grid item lg={3} xs={12} sm={12} md={4}>
              <FormLabels label={"From"} isRequired={false} />
              <DatePicker
                maxDateEnable={false}
                value={startDate}
                disabled={false}
                onChangeHandler={(e) => onchangeStartdatePicker(e)}
              />
            </Grid>
            <Grid item lg={3} xs={12} sm={12} md={4}>
              <FormLabels label={"To"} isRequired={false} />
              <DatePicker
                maxDateEnable={false}
                minDate={startDate}
                value={endDate}
                disabled={false}
                onChangeHandler={(e) => onchangeEnddatePicker(e)}
              />
            </Grid>
          </Grid>
        </>
      ) : null}
      <section className="grid_main_sec">
        <div className="grid_main_header two_grid">
          <div className="grid_heading_style">Inspection Reports</div>
        </div>
        <div className="grid_main_body">
          <div className="filter_of_caselist">
            <div className="searchcaseid">
              <label htmlFor="search">
                <span>
                  <SearchIcon />
                </span>
                <div>
                  <input
                    id="search"
                    placeholder="Search Inspection Report"
                    type="text"
                    value={search}
                    className=""
                    onChange={handleautoSearch}
                    autoComplete="off"
                  />
                </div>
              </label>
            </div>
            <div className="filter_btn">
              <button
                aria-describedby={id}
                variant="contained"
                type="button"
                name="btn"
                onClick={(e) => handleClick(e)}
              >
                <FilterListIcon id="icn" /> Filters
              </button>
              <UserFilterList
                secondLabel="Inspection Type"
                firstLabel="Frequency"
                id={id}
                open={open}
                anchorEl={anchorEl}
                handleClose={handleClose}
                secondLebelValue={isnepectionTypeId}
                firstLebelValue={frequencyTypeId}
                handleSearch={handleSearch}
                handleApply={handleApply}
                handleClear={handleClear}
                secondLebelFilter={inspectionTypeValue?.insTypeMstList}
                firstLebelFilter={inspectionTypeValue?.insfrequencyList}
                resetBtn={true}
                secondLebelOnChanges={inspectionTypeIdOnChanges}
                firstLebelOnChanges={frequencyTypesOnChanges}
                isShow={
                  dashboardReportPath ||
                  isnepectionTypeId === 1 ||
                  (isnepectionTypeId === 3 && true)
                }
                InspectionSubmitTypeShowshow={statusId === 6 ? true : false}
                inspectionSubmitType={inspectionSubmitType}
                InspectionSubmitTypeOnChanges={InspectionSubmitTypeOnChanges}
              />
            </div>
          </div>

          <div className="desc_box row_uniq">
            <div className="table_style_ui ">
              <GridTable
                getRowId={(r) => r.reportId}
                rows={getSwInspectionList?.inspectionReports ?? []}
                rowCount={getSwInspectionList?.recordsCount ?? 0}
                columns={dashboardReportPath ? getColumns() : credcloumns}
                //loading={autoSearchDataLoading}
                checkboxSelection={false}
                page={page}
                pagination
                pageSize={pageSize}
                rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                onPageSizeChange={handlePageSizeChange}
                onPageChange={handlePagignation}
                backIconButtonProps={{ disabled: false }}
                disableSelectionOnClick
                components={{
                  LoadingOverlay: TableLoader,
                  NoRowsOverlay: NORow,
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <Popover
        open={Boolean(deferLogAnchorEl)}
        anchorEl={deferLogAnchorEl}
        onClose={handleCloseDeferLog}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <div className="deferral-log-popup">
          <div className="deferral-log-title">Deferral Log</div>
          {deferLogRows?.map((val, index) => (
            <div key={index} className="deferral-log-entry">
              <div>
                <span className="deferral-log-label">Date:</span>{" "}
                {stripTimeToDate(val?.deferredOn || "") ?? "N/A"}
              </div>
              <div>
                <span className="deferral-log-label">Deferred By:</span>{" "}
                {val?.userName ?? "N/A"}
              </div>
              <div>
                <span className="deferral-log-label">Reason:</span>{" "}
                {val?.deferredReason || val?.deferredOtherReason || "N/A"}
              </div>
              <div>
                <span className="deferral-log-label">Other Reason:</span>{" "}
                {val?.deferredOtherReason || val?.deferredOtherReason || "N/A"}
              </div>
            </div>
          ))}
        </div>
      </Popover>
    </div>
  );
}

export default SwInspectionReports;
